function indexValue(obj,is, value) {
    if (typeof is == 'string')
        return indexValue(obj,is.split('.'), value);
    else if (is.length==1 && value!==undefined)
        return obj[is[0]] = value;
    else if (is.length==0)
        return obj;
    else
        return indexValue(obj[is[0]],is.slice(1), value);
};

function urlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

	return results && results[1] ? results[1] : null;
}

const Screen = {
    width: function(unit) {
        return window.innerWidth + ( unit || '' );
    },
    height: function(unit) {
        return window.innerHeight + ( unit || '' );
    }
};

export {
    indexValue,
    urlParam,
    Screen,
};